import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data/turboData";

const Testimonials = () => (
  <section className="relative py-20 md:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6">
      <div className="grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <div className="text-xs uppercase tracking-[0.2em] text-[var(--tt-accent)] font-semibold">
            Real customers
          </div>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-[var(--tt-navy)] mt-3 leading-[1.05]">
            Stories from the people we ship for.
          </h2>
          <div className="mt-6 flex items-center gap-3">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-5 w-5 fill-[var(--tt-accent)] text-[var(--tt-accent)]" />
              ))}
            </div>
            <div className="text-sm text-[var(--tt-ink-soft)]">
              <span className="font-semibold text-[var(--tt-navy)]">4.8 / 5</span> from 600+ reviews
            </div>
          </div>
        </div>
        <div className="lg:col-span-8 grid md:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={i}
              className={`card p-6 relative ${i === 1 ? "md:mt-10" : ""}`}
            >
              <Quote className="absolute -top-3 left-6 h-6 w-6 text-[var(--tt-accent)]" />
              <blockquote className="text-[15px] text-[var(--tt-ink)] leading-relaxed pt-2">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-5 pt-4 border-t border-[var(--tt-line)]">
                <div className="font-semibold text-[var(--tt-navy)] text-sm">{t.name}</div>
                <div className="text-xs text-[var(--tt-muted)] mt-0.5">{t.role}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Testimonials;
